var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "credit-card_4_",
    "data-name": "credit-card (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.962,
    height: 11.972,
    viewBox: "0 0 15.962 11.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 15.962,
    height: 1.33,
    transform: "translate(0 3.325)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M0,259.991a2,2,0,0,0,2,2H13.967a2,2,0,0,0,2-2V256H0Zm9.311-3.325H13.3a.665.665,0,1,1,0,1.33H9.311a.665.665,0,1,1,0-1.33Zm-6.181,1.8c.386.419.913,0,1.272-.224a.673.673,0,0,1,.91.239c.176.314,1.026-.229,1.368-.21a1.138,1.138,0,0,1,.938.555c.505.692-.649,1.355-1.149.671.271.371-1.022.5-1.231.465a1.409,1.409,0,0,1-.658-.307A1.906,1.906,0,0,1,2.19,259.4C1.611,258.771,2.55,257.829,3.131,258.461Z",
    transform: "translate(0 -250.014)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M13.967,64H2a2,2,0,0,0-2,2H15.962A2,2,0,0,0,13.967,64Z",
    transform: "translate(0 -64)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.637054e5662b9e58ab5b5a1d71757947.svg";
export { ForwardRef as ReactComponent };